// component
import SvgColor from '../../../components/svg-color';

// ----------------------------------------------------------------------
// /assets/icons/navbar/${name}.svg
const icon = (name) => (
  <SvgColor src={`${process.env.PUBLIC_URL}/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ProductionReports = [
      {
        title: 'Production Report Card',
        path: '/dashboard/reports/pr_production',
        icon: icon('reportpr'),
        ShortName: 'Reports_ProductionReportCard',
      },
      {
        title: 'Production Hrs Wise',
        path: '/dashboard/reports/pr_production_hourly',
        icon: icon('hourly'),
        ShortName: 'Reports_ProductionHrsWise',
      },
      {
        title: 'PR Skill Matrix',
        path: '/dashboard/reports/pr_skillmatrix',
        icon: icon('skills'),
        ShortName: 'Reports_SkillMatrixPR',
      },
];

export default ProductionReports;
